import React, { useContext, useEffect, useState } from 'react';
import { MethodData, useAxios } from '../../custom-axios/CustomAxios';
import { findOrSendInvitationPath } from '../../api/Api';
import { IUser, UserContext } from '../../../contexts/user/UserContext';
import SigninOptions from '../../../components/auth/SigninOptions';
import SigninEmail from '../../../components/auth/SigninEmail';
import CheckYourEmail from '../../../components/auth/CheckYourEmail';
import AuthContainer from '../../../components/auth/AuthContainer';
import { removeRedirectUrl, setRedirectUrl } from '../../reducer/user/UserReducerDispatch';
import { useRouter } from 'next/router';
import { LocalStorageContext } from '../../../contexts/storage/LocalStorageContext';
import { updateStorageData } from '../../../contexts/storage/LocalStorageProvider';

interface ISigninProps {
    isModal: boolean;
    onSuccess?: () => void;
    userData?: IUser | null;
}

enum Step {
    SIGNIN_OPTIONS = 'signin_options',
    SIGNIN_EMAIL = 'signin_email',
    CHECK_EMAIL = 'check_email'
}

const Signin: React.FC<ISigninProps> = ({isModal, onSuccess, userData}) => {
    const router = useRouter();
    const {dispatch} = useContext(UserContext);
    const {rdRedirectUrl, purchaseIntentData, rdLastSearch} = useContext(LocalStorageContext);
    const [step, setStep] = useState<Step>(Step.SIGNIN_OPTIONS);
    const [email, setEmail] = useState('');
    const {fetch} = useAxios();

    useEffect(() => {
        const handleRouteChange = ((url: string) => {
            if(!url.includes('signup') && router.asPath.includes('signup')) {
                setStep(Step.SIGNIN_OPTIONS)
            }
        });

        router.events.on('beforeHistoryChange', handleRouteChange);
        return () => {
            router.events.off('beforeHistoryChange', handleRouteChange);
        };
    }, [router])

    const onSubmit = (data:any) => {
        fetch(findOrSendInvitationPath, {
            method: MethodData.POST,
            body: {
                email: data.email,
                storage: {
                    rdRedirectUrl, purchaseIntentData, rdLastSearch
                }
            }
        }).then((response: {emailExists: boolean}) => {
            setEmail(data.email);
            isModal && dispatch?.(setRedirectUrl(location.pathname));
            if (response.emailExists) {
                setStep(Step.SIGNIN_EMAIL);
            } else {
                router.push(`${router.asPath}?signup`)
                setStep(Step.CHECK_EMAIL);
                dispatch?.(removeRedirectUrl());
                updateStorageData?.('purchaseIntentData', '');
            }
        })
    }

    const showOptions = () => {
        setStep(Step.SIGNIN_OPTIONS);
    }

    const getView = () => {
        switch(step) {
            case Step.SIGNIN_OPTIONS:
                return <SigninOptions isModal={isModal} userData={userData} onSubmit={onSubmit} />
            case Step.SIGNIN_EMAIL:
                return <SigninEmail isModal={isModal} email={email} onSuccess={onSuccess} goBack={showOptions} />
            case Step.CHECK_EMAIL:
                return <CheckYourEmail email={email} goBack={showOptions} />
        }
    }

    return (
        <AuthContainer isModal={isModal}>
            {getView()}
        </AuthContainer>
    );
};

export default Signin;
